import {Injectable} from '@angular/core';
import {SettingsService} from './settings.service';
import {HttpClient} from '@angular/common/http';
// import {Dictionary, Location, City} from 'app/models';
import {Dictionary, } from 'app/models';
import {Observable, Subject,  EMPTY} from 'rxjs';
import { refCount, publishReplay, map, catchError} from 'rxjs/operators';

import {Currency} from '../models/currency.model';
import * as moment from "moment";

@Injectable()
export class DictionaryService {
  apiUrl: string;
  roles: Dictionary[];
  branches: Dictionary[];
  ageCategories: Dictionary[];
  travelStatuses: Dictionary[];
  serviceStatuses: Dictionary[];
  invoiceStatuses: Dictionary[];
  managers: Dictionary[];
  services: Dictionary[];
  private onGetRoles = new Subject<any>();
  private onGetBranches = new Subject<any>();
  private onGetAgeCategories = new Subject<any>();
  private onGetTravelStatuses = new Subject<any>();
  private onGetServiceStatuses = new Subject<any>();
  private onGetInvoiceStatuses = new Subject<any>();
  private onGetPayment = new Subject<any>();
  private onGetManagers = new Subject<any>();
  private onGetServices = new Subject<any>();
  private onGetCurrency = new Subject<any>();
  private onGetLocationsCountries = new Subject<any>();

  /** cached data */
  private _citiesCache = new Map<string, Observable<any>>();


  constructor(private http: HttpClient,
              private settings: SettingsService) {
    this.apiUrl = this.settings.apiUrl;
  }

  getRoles(): Observable<Dictionary[]> {
    this._getData(this.roles, `/dictionary/roles`, this.onGetRoles);
    return this.onGetRoles.asObservable();
  }

  getManagers(): Observable<Dictionary[]> {
    // this._getData(null, `/dictionary/managers`, this.onGetManagers);
    // return this.onGetManagers.asObservable();

    return this.http.get(`${this.apiUrl}/dictionary/managers`).pipe(map((resp: any) => {
      return resp.map((item) => {

          return {...item, text: item.name}

      });
    }));
  }

  getServices(): Observable<Dictionary[]> {
    this._getData(null, `/dictionary/services`, this.onGetServices);
    return this.onGetServices.asObservable();
  }

  // getPaymentMethod(): Observable<Dictionary[]> {
  //   this._getData(null, `/dictionary/payment-methods`, this.onGetPayment);
  //   return this.onGetPayment.asObservable();
  // }
  // getCurrency(): Observable<Dictionary[]> {
  //   this._getData(null, `/dictionary/currencies`, this.onGetCurrency);
  //   return this.onGetCurrency.asObservable();
  // }
  // getInvoicesTemplate(): Observable<Currency[]> {
  //   return this.http.get(`${this.apiUrl}/dictionary/invoice-types`).pipe(map((resp: any) => {
  //     return resp.map((item, i) => new Currency().setFromApiModel(item, i));
  //   }));
  // }
  //
  // getBranches(): Observable<Dictionary[]> {
  //   this._getData(this.branches, `/dictionary/branches`, this.onGetBranches);
  //   return this.onGetBranches.asObservable();
  // }
  //
  // getLocationsDict(): Observable<any> {
  //   return this.http.get(`${this.apiUrl}/dictionary/locations`).pipe(map((resp: any) => {
  //     return resp.map(worldPart => {
  //       return {
  //         id: worldPart.id,
  //         text: worldPart.name,
  //         countries: worldPart.countries.map(country => {
  //           return {...country, text: country.name}
  //         })
  //       }
  //
  //
  //
  //     } );
  //   }));
  // }
  //
  //
  // getLocationsCountries(): Observable<Dictionary[]> {
  //   this._getData(null, `/dictionary/countries`, this.onGetLocationsCountries);
  //   return this.onGetLocationsCountries.asObservable();
  // }
  //
  //
  //
  // oldgetCitiesList(str: string, countryCode: string, offset: number): Observable<Dictionary[]> {
  //   return this.http.get(`${this.apiUrl}/dictionary/cities?name=${str}&country_code=${countryCode}&offset=${0}`)
  //     .pipe(map((resp: any) => {
  //     // return resp.data;
  //     return resp.data.map(item => {
  //       return {...item, text: item.name}
  //     });
  //   }));
  // }
  //
  // //the API are cached to avoid exceeding of the limit of free 1000 calls per day
  // getCitiesList(params: any = {}): Observable<any> {
  //   // console.log('!!!!this._citiesCache', this._citiesCache)
  //   const key = JSON.stringify(params);
  //   if (!this._citiesCache.has(key)) {
  //     const response = this.http.get(`${this.apiUrl}/dictionary/cities?name=${params.str}&country_code=${params.countryCode}&offset=${0}`)
  //       .pipe(map((resp: any) => {
  //         // return resp.data;
  //         return resp.data.map(item => {
  //           return {...item, text: item.name}
  //         });
  //       }),
  //       publishReplay(1),
  //       refCount(),
  //         catchError(err => {
  //           delete this._citiesCache[key];
  //           return EMPTY;
  //         }
  //     ));
  //     this._citiesCache.set(key, response);
  //   }
  //   return this._citiesCache.get(key);
  // }
  //
  //
  // getCitiesSearch(str: string): Observable<any> {
  //   return this.http.get(`${this.apiUrl}/locations/cities?name=${str}`).pipe(map((resp: any) => {
  //     return resp.map(item => new City().setFromApiModel(item));
  //   }));
  //
  // }
  //
  //
  // getClientsSearch(str: string): Observable<any> {
  //   return this.http.get(`${this.apiUrl}/dictionary/clients?name=${str}`).pipe(map((resp: any) => {
  //     return resp.map(item => {
  //       return {id: item.id, name: item.name, text: item.name, files: item.files,
  //         ageType: {text: item.age_category ? item.age_category.name : ''} , birthday: moment(item.birthday) };
  //     });
  //   }));
  //
  // }

  getAgeCategories(): Observable<Dictionary[]> {
    this._getData(this.ageCategories, `/dictionary/age-categories`, this.onGetAgeCategories);
    return this.onGetAgeCategories.asObservable();
  }

  // getTravelStatuses(): Observable<Dictionary[]> {
  //   this._getData(this.travelStatuses, `/dictionary/travel-statuses`, this.onGetTravelStatuses);
  //   return this.onGetTravelStatuses.asObservable();
  // }
  //
  // getServiceStatuses(): Observable<Dictionary[]> {
  //   this._getData(this.serviceStatuses, `/dictionary/service-statuses`, this.onGetServiceStatuses);
  //   return this.onGetServiceStatuses.asObservable();
  // }
  //
  // getInvoiceStatuses(): Observable<Dictionary[]> {
  //   this._getData(this.invoiceStatuses, `/dictionary/invoice-statuses`, this.onGetInvoiceStatuses);
  //   return this.onGetInvoiceStatuses.asObservable();
  // }
  //
  getInvoicesTemplate(): Observable<Currency[]> {
    return this.http.get(`${this.apiUrl}/dictionary/invoice-types`).pipe(map((resp: any) => {
      return resp.map((item, i) => new Currency().setFromApiModel(item, i));
    }));
  }

  private _getData(list, url, subject) {
    if (list) {
      setTimeout(() => {
        subject.next(list);
      }, 4);
    } else {
      this.http.get(`${this.apiUrl}${url}`).subscribe((resp: any) => {
        list = resp.map(item => new Dictionary().setFromApiModel(item));
        subject.next(list);
      });
    }
  }
}
